// extracted by mini-css-extract-plugin
export default {"container":"_Z-z","heading":"a0-z","links":"b0-z","copy":"c0-z","subCopy":"d0-z","linksLeft":"e0-z","linksCenter":"f0-z","linksRight":"g0-z","link":"h0-z","onlyLink":"i0-z"};